import { gql } from '@apollo/client';

export const READ_SALES_ORDER_PMC_PROMOTION = gql`
  query ReadSalesOrderPmcPromotion($pmcId: ID!, $paymentMethod: PaymentType!) {
    readSalesOrderPmcPromotion(pmcId: $pmcId, paymentMethod: $paymentMethod) {
      addAutomatically
      name {
        en
        fi
        no
        sv
      }
      discountPercent
      uid
      discountValidity {
        validFrom
        validTo
      }
      discountValue
    }
  }
`;
